import store from 'store'

// Última elección del usuario sobre el menú izquierdo (true = colapsado). Se guarda solo cuando
// el usuario pulsa el trigger del menú; el colapso automático por ancho de ventana no la toca.
const MENU_COLLAPSED_PREFERENCE_KEY = 'app.menu.isCollapsedPreference'

// Por defecto el menú arranca colapsado, como hasta ahora.
export const getMenuCollapsedPreference = () => {
  const value = store.get(MENU_COLLAPSED_PREFERENCE_KEY)
  return typeof value === 'boolean' ? value : true
}

export const setMenuCollapsedPreference = collapsed => {
  store.set(MENU_COLLAPSED_PREFERENCE_KEY, collapsed === true)
}

// Por debajo de este ancho el menú se fuerza colapsado, sea cual sea la preferencia.
const MENU_FORCED_COLLAPSE_WIDTH = 1024

// Estado de colapso que toca ahora: forzado en ventanas estrechas, la preferencia en el resto.
export const resolveMenuCollapsed = () =>
  window.innerWidth < MENU_FORCED_COLLAPSE_WIDTH ? true : getMenuCollapsedPreference()
